import React from "react";
import TextField from "@material-ui/core/TextField";

function ReachTextField(props) {
  const { value } = props;
  return <TextField variant="outlined" {...props} value={value || ""} />;
}

export default ReachTextField;
